<template>
  <el-row class="container">
    <el-col :offset="4" :span="16">
      <logo :title="legal.title" :primary-color="primaryColor"></logo>

      <div class="body">{{ legal.content }}</div>
      <div class="last_update" v-if="isUpdated">Last Updated on <span id="last_update">{{ legal.lastUpdate }}</span></div>
      <div class="last_update" v-else>Never Updated.</div>

      <company :name="footer.companyName" :url="footer.companyUrl" :address="footer.companyAddress" :contact="footer.companyContact" :primary-color="primaryColor"></company>
    </el-col>
  </el-row>
</template>

<script>
  import main from './Legal.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import '../style.scss';
  @import './Legal.scss';
</style>



// WEBPACK FOOTER //
// Legal.vue?5603079f